import {baseUrl} from '../utils/requestUrl'
import { authFetch } from '../utils/authFetch';

export  const fetchFunctionalCheckist = async() => {
    const patientId = localStorage.getItem('patient')
    const response = await authFetch(`${baseUrl}/checklists/patient/${patientId}`);
    
    return response.json(); 
}
export const fetchOrgFunctionalChecklistById = async(checklistId) => {
    const response = await authFetch(`${baseUrl}/checklists/${checklistId}`);
    return response.json();
}
export const addFunctionalScore = async(data)=>{
    const response = await authFetch(`${baseUrl}/scores`, {
        method:'POST',
        body:JSON.stringify(data),
       
    });
    return response.json();
}
export const fetchFunctionalChecklistById = async(id) => {
    const response = await authFetch(`${baseUrl}/scores/byEntryId/${id}`);
    
    return response.json();
}
export const updateFunctionalScore = async(scoreId, data) => {
    const response = await authFetch(`${baseUrl}/scores/byEntryId/${scoreId}`, {
        method: 'PUT',
        body: JSON.stringify(data),
    });
    return response.json();
}
export const amendFunctionalScore = async(entryId, data) => {
    const response = await authFetch(`${baseUrl}/scores/byEntryId/${entryId}/amend`, {
        method: 'POST',
        body: JSON.stringify(data),
    });
    return response.json();
}
export const getFunctionalLists = () => {
    return [
        {
            checklistId: 'C010',
            title:'Reynolds, Bruce',
            type:'Custom',
            status:'Archived',
            createdDate: '2 July 1964',
        },
        {
            checklistId: 'G011',
            title:'Depression',
            type:'Generic',
            status:'Active',
            createdDate: '2 July 1964',
        },
        {
            checklistId: 'GO45',
            title:'Diabetes',
            type:'Generic',
            status:'Active',
            createdDate: '2 July 1964',
        },
        {
            checklistId: 'G057',
            title:'PTSD',
            type:'Generic',
            status:'Active',
            createdDate: '2 July 1964',
        },
        {
            checklistId: 'G061',
            title:'Stroke',
            type:'Generic',
            status:'Active',
            createdDate: '2 July 1964',
        }
    ]
}
